commons.filter('tariffsFilter', () => {
    "use strict";
    const RATE = 0.003;
    const VAT_RATE = 1.2;
    const MAX_TARIFF = 11980.80;

    return (amount, currency, exchangeRates) => {
        if (exchangeRates) {
            let amountExchanged = currency === 'UAH' ? amount : amount * exchangeRates[currency].rate;
            let tariff = Number(amountExchanged * RATE * VAT_RATE).toFixed(2);

            return Math.min(tariff, MAX_TARIFF);
        } else {
            // console.warn('No exchangeRates' );
        }
    };
});
